var map = {
	"./Black_Account_Icons-01.png": 565,
	"./Black_Account_Icons-02.png": 566,
	"./Black_Account_Icons-03.png": 567,
	"./Black_Account_Icons-04.png": 568,
	"./Black_Account_Icons-05.png": 569,
	"./Black_Account_Icons-06.png": 570,
	"./Black_Account_Icons-07.png": 571,
	"./Black_Account_Icons-08.png": 572,
	"./Black_Account_Icons-09.png": 573,
	"./Black_Account_Icons-10.png": 574,
	"./Black_Account_Icons-11.png": 575,
	"./Black_Account_Icons-12.png": 576,
	"./Black_Account_Icons-13.png": 577,
	"./Black_Account_Icons-14.png": 578,
	"./FilePresentOutlined.svg": 579,
	"./accuracyAccountsDemo_downloadMT4.jpg": 580,
	"./accuracyAccountsReal_downloadMT4.jpg": 581,
	"./alert@2x.svg": 582,
	"./apple-brands.svg": 583,
	"./arrow_up_from_box.svg": 584,
	"./bankWire.svg": 585,
	"./bdswissDemo_downloadMT4.png": 586,
	"./bdswissGlobalDemo_downloadMT4.png": 587,
	"./bdswissGlobalReal02_downloadMT4.png": 588,
	"./bdswissGlobalReal03_downloadMT4.png": 589,
	"./bdswissGlobalReal04_downloadMT4.png": 590,
	"./bdswissGlobalReal05_downloadMT4.png": 591,
	"./bdswissGlobalReal_downloadMT4.png": 592,
	"./bdswissGlobalReal_downloadMT5.png": 593,
	"./bdswissReal02_downloadMT4.png": 594,
	"./bdswissReal03_downloadMT4.png": 595,
	"./bdswissReal04_downloadMT4.png": 596,
	"./bdswissReal05_downloadMT4.png": 597,
	"./bdswissReal_downloadMT4.png": 598,
	"./bdswissReal_downloadMT5.png": 599,
	"./bdswissSCDemo_downloadMT4.png": 600,
	"./bdswissSCReal01_downloadMT4.png": 601,
	"./bdswissSCReal02_downloadMT4.png": 602,
	"./bdswissSCReal03_downloadMT4.png": 603,
	"./bdswissSCReal04_downloadMT4.png": 604,
	"./bdswissSCReal05_downloadMT4.png": 605,
	"./bdswiss_grey.png": 606,
	"./bdswiss_white.png": 607,
	"./bg-image-affiliate.png": 608,
	"./bitwallet-bdSwiss-dark.svg": 609,
	"./bitwallet-bdSwiss-light.svg": 610,
	"./bitwallet-swissMarkets-dark.svg": 611,
	"./bitwallet-swissMarkets-light.svg": 612,
	"./card.svg": 613,
	"./check_circle.png": 614,
	"./chf.png": 615,
	"./competitions.png": 616,
	"./complimentary@2x.svg": 617,
	"./control-radio-off.png": 618,
	"./control-radio-on.png": 619,
	"./crypto.svg": 620,
	"./cvv.svg": 621,
	"./deposit-card.svg": 622,
	"./diners.png": 623,
	"./dkk.png": 624,
	"./document-upload-failure-dark.png": 625,
	"./document-upload-failure-light.png": 626,
	"./document-upload-success-black.png": 627,
	"./document-upload-success-dark.png": 628,
	"./document-upload-success-light.png": 629,
	"./documents-empty-dark.png": 630,
	"./documents-empty-light.png": 631,
	"./downloadPdf-light.png": 632,
	"./downloadPdf.png": 633,
	"./dpWorldTourChampionship-dark.svg": 634,
	"./dpWorldTourChampionship-light.svg": 635,
	"./eWallet.svg": 636,
	"./eur.png": 637,
	"./exp-date.svg": 638,
	"./fees@2x.svg": 639,
	"./filterIcon.png": 640,
	"./gbp.png": 641,
	"./icon-add-account.svg": 362,
	"./icon-appstore@2x.png": 642,
	"./icon-arrow-right-dark.png": 643,
	"./icon-arrow-right-light.png": 644,
	"./icon-bank-wire.svg": 645,
	"./icon-checkbox.svg": 646,
	"./icon-close-dark.svg": 647,
	"./icon-close-light.svg": 648,
	"./icon-close.png": 649,
	"./icon-contact-callback@2x.png": 650,
	"./icon-contact-callback@2x.svg": 651,
	"./icon-contact-chat@2x.png": 363,
	"./icon-contact-chat@2x.svg": 364,
	"./icon-contact-email@2x.png": 652,
	"./icon-contact-email@2x.svg": 653,
	"./icon-contact-faqs@2x.png": 654,
	"./icon-contact-faqs@2x.svg": 655,
	"./icon-contact-oneOnOneSession@2x.png": 656,
	"./icon-contact-telegram@2x.png": 657,
	"./icon-contact-whatsapp@2x.png": 658,
	"./icon-crypto.svg": 659,
	"./icon-document.svg": 660,
	"./icon-facebook@2x.png": 661,
	"./icon-google-play@2x.png": 662,
	"./icon-notification.svg": 663,
	"./icon-profile-big.svg": 664,
	"./icon-profile.svg": 665,
	"./icon-spoa.svg": 666,
	"./icon-swapFree.svg": 667,
	"./icon-telegram@2x.png": 668,
	"./icon-twitter@2x.png": 669,
	"./icon_accounts_dashboard.svg": 670,
	"./icon_logout_dashboard.svg": 671,
	"./icon_notification_dashboard.svg": 672,
	"./icon_profilesettings_dashboard.svg": 673,
	"./icon_support_dashboard.svg": 674,
	"./icon_transaction_dashboard.svg": 675,
	"./jcb.png": 676,
	"./languages.png": 677,
	"./limit-failure-dark.png": 678,
	"./limit-failure-light.png": 679,
	"./logo-accuracy.png": 680,
	"./logo-bdstrading-white.svg": 681,
	"./logo-bdstrading.svg": 682,
	"./logo-bdswiss-white.svg": 683,
	"./logo-bdswiss.png": 684,
	"./logo-bdswiss.svg": 685,
	"./logo-equityflow-black.png": 686,
	"./logo-equityflow-white.png": 687,
	"./logo-facebook.png": 688,
	"./logo-google.png": 689,
	"./logo-lydian-black.png": 690,
	"./logo-lydian-black.svg": 691,
	"./logo-lydian-white.svg": 692,
	"./logo-regalx-white.png": 693,
	"./logo-regalx.png": 694,
	"./logo-skyground-black.svg": 695,
	"./logo-skyground-white.svg": 696,
	"./logo-swissmarkets-white.svg": 697,
	"./logo-swissmarkets.png": 698,
	"./logo-swissmarkets.svg": 699,
	"./logo-tauromarkets-black.png": 700,
	"./logo-tauromarkets-white.png": 701,
	"./logo-tauromarkets-white2.png": 702,
	"./logo-tauromarkets-white2.svg": 703,
	"./logo-valutamarkets.png": 704,
	"./lydian/login-bg.png": 1232,
	"./lydian/logo.svg": 1233,
	"./lydian/lydian-trading-academy-coming_soon.png": 1234,
	"./lydian/lydian-trading-academy.png": 1235,
	"./lydian/lydian-watermark.png": 382,
	"./lydian/trading-academy-logo.svg": 383,
	"./lydian/user-icon.svg": 1236,
	"./maestro.png": 705,
	"./mastercard.png": 706,
	"./mastercard_logo_icon.svg": 707,
	"./mercedesCup-dark.svg": 708,
	"./mercedesCup-light.svg": 709,
	"./mobile/accounts.svg": 1237,
	"./mobile/more.svg": 1238,
	"./mobile/notifications.svg": 1239,
	"./mobile/payments.svg": 1240,
	"./nationalIdBR.png": 710,
	"./nationalIdES.jpg": 711,
	"./nationalIdIT.jpg": 712,
	"./nationalIdZA.png": 713,
	"./no-trades-dark.png": 714,
	"./no-trades-light.png": 715,
	"./no-trading-signals-dark.png": 716,
	"./nok.png": 717,
	"./notifications-empty-dark.png": 718,
	"./notifications-empty-light.png": 719,
	"./onlineBanking.svg": 720,
	"./onlineDeposit.svg": 721,
	"./page-not-found-dark.svg": 365,
	"./page-not-found-light.svg": 366,
	"./payment-failure-dark.png": 722,
	"./payment-failure-light.png": 723,
	"./payment-pending-dark.png": 724,
	"./payment-pending-light.png": 725,
	"./payment-success-dark.png": 726,
	"./payment-success-light.png": 727,
	"./payments-history-empty-dark.png": 728,
	"./payments-history-empty-light.png": 729,
	"./phone_verification.png": 730,
	"./place1-leadership.png": 731,
	"./place2-leadership.png": 732,
	"./place3-leadership.png": 733,
	"./pln.png": 734,
	"./pof-bankStatement.png": 735,
	"./pof-bankStatementPOF.png": 736,
	"./pof-card-back.png": 737,
	"./pof-card.png": 738,
	"./pof-cardStatement.png": 739,
	"./pof-other.png": 740,
	"./pof-proofOfResidence.png": 741,
	"./pof-swiftCopyPaymentAdvice.png": 742,
	"./pof-virtualCard.png": 743,
	"./poi-document.png": 744,
	"./poi-drivingLicense-back.png": 745,
	"./poi-drivingLicense.png": 746,
	"./poi-id-back.png": 747,
	"./poi-id.png": 748,
	"./poi-passport.png": 749,
	"./por-bankStatementPOR.png": 750,
	"./por-document.png": 751,
	"./por-proofOfResidence.png": 752,
	"./por-utilityBill.png": 753,
	"./priority@2x.svg": 754,
	"./referAndEarn.png": 755,
	"./regalxDemo_downloadMT4.png": 756,
	"./regalxReal01_downloadMT4.png": 757,
	"./regalxReal02_downloadMT4.png": 758,
	"./regalxReal03_downloadMT4.png": 759,
	"./regalxReal04_downloadMT4.png": 760,
	"./regalxReal05_downloadMT4.png": 761,
	"./register-referral-light.png": 762,
	"./sek.png": 763,
	"./sign-up.png": 764,
	"./spaceship.png": 765,
	"./spreads@2x.svg": 766,
	"./support@2x.svg": 767,
	"./swissmarketsDemo_downloadMT4.png": 768,
	"./swissmarketsReal02_downloadMT4.png": 769,
	"./swissmarketsReal_downloadMT4.png": 770,
	"./tauroDemo01DownloadMT4.jpg": 771,
	"./tauroReal01DownloadMT4.jpg": 772,
	"./technicalIndicator-ebook.png": 773,
	"./technicalIndicatorItem.svg": 774,
	"./telegram-dark.png": 775,
	"./telegram.png": 776,
	"./trading-alerts-tradingAlerts-dark.png": 777,
	"./trading-alerts-tradingAlerts-light.png": 778,
	"./tradingPsychology-ebook.png": 779,
	"./tradingPsychologyItem.svg": 780,
	"./transfer-external.svg": 781,
	"./transfer-internal.svg": 782,
	"./transfer-spoa.svg": 783,
	"./unlockYourTradingPotentialBanner/education_desktop.webp": 502,
	"./unlockYourTradingPotentialBanner/education_mobile.webp": 503,
	"./upload-bankStatement-error.png": 784,
	"./upload-bankStatement-success.png": 785,
	"./upload-bankStatement.png": 786,
	"./upload-document-dark.png": 787,
	"./upload-document-light.png": 788,
	"./upload-generic-error.png": 789,
	"./upload-generic-success.png": 790,
	"./upload-generic.png": 791,
	"./upload-pof-back-card-error.png": 792,
	"./upload-pof-back-card-success.png": 793,
	"./upload-pof-back-card.png": 794,
	"./upload-pof-front-card-error.png": 795,
	"./upload-pof-front-card-success.png": 796,
	"./upload-pof-front-card.png": 797,
	"./upload-poi-back-drivingLicense-error.png": 798,
	"./upload-poi-back-drivingLicense-success.png": 799,
	"./upload-poi-back-drivingLicense.png": 800,
	"./upload-poi-back-error.png": 801,
	"./upload-poi-back-success.png": 802,
	"./upload-poi-back.png": 803,
	"./upload-poi-front-drivingLicense-error.png": 804,
	"./upload-poi-front-drivingLicense-success.png": 805,
	"./upload-poi-front-drivingLicense.png": 806,
	"./upload-poi-front-error.png": 807,
	"./upload-poi-front-success.png": 808,
	"./upload-poi-front.png": 809,
	"./upload-por-front-error.png": 810,
	"./upload-por-front-proofOfResidence-error.png": 811,
	"./upload-por-front-proofOfResidence-success.png": 812,
	"./upload-por-front-proofOfResidence.png": 813,
	"./upload-por-front-success.png": 814,
	"./upload-por-front-utilityBill-error.png": 815,
	"./upload-por-front-utilityBill-success.png": 816,
	"./upload-por-front-utilityBill.png": 817,
	"./upload-por-front.png": 818,
	"./usd.png": 819,
	"./visa.png": 820,
	"./visa_logo_icon.svg": 821,
	"./vps-enter-credentials.png": 822,
	"./vps-remote-desktop-windows.png": 823,
	"./vps-remote-desktop.png": 824,
	"./waiting-list-skip-dark.png": 825,
	"./waiting-list-skip.png": 826,
	"./windows-brands.svg": 827
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 829;